<template>
    <div class="content">
        <form @submit="handleSubmit" v-if="customer.health_information">
            <div>
                <div class="input-box" v-for="(allergy, x) in allergies" v-bind:key="x">
                    <span class="trash-icon">
                        <font-awesome-icon @click="reomveAllergy(x)" class="trash-svg" :icon="['fa', 'trash-alt']" />
                    </span>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Digite aqui sua alergia"
                        v-model="allergies[x]" />
                    <small class="error" v-if="errors && errors[x]">{{errors[x]}}</small>
                </div>
            </div>
            <button @click.prevent="addAllergy" class="button btn-secondary btn-plus" style="width:100%;">+</button>
            <button @click.prevent="handleSubmit" class="button btn-primary" v-if="!loading">Salvar</button>
            <button class="button btn-primary" disabled v-if="loading">
              <loading/>
            </button>
        </form>
    </div>
</template>

<script>
  import {GET_CUSTOMER, POST_CUSTOMER} from '../../services/customer';

  import { library } from '@fortawesome/fontawesome-svg-core'
  import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

  library.add(faTrashAlt);

  export default {
    props: ['values'],
    name: "edit-allergies",
    data() {
          return {
            loading: false,
            loadingScreen: false,
            customer: {},
            allergies: [''],
            errors: [],
          }
        },
    methods: {
      outsideClick() {
          if(event.target === event.currentTarget)
              this.$emit('close');
      },
      async getCustomer() {
        this.$emit('setLoadingScreen', true);

        try {
          const data = await GET_CUSTOMER();
          this.customer = data.customer;

          if(this.customer.health_information != null && this.customer.health_information.allergies)
            this.allergies = this.customer.health_information.allergies;

          if(this.allergies.length == 0)
            this.allergies = [''];
            
          if(this.customer.health_information == null){
            this.customer.health_information = {};
            this.customer.health_information.allergies = [''];
          }else if( this.customer.health_information && !this.customer.health_information.allergies ){
            this.customer.health_information.allergies = [''];
          }
        } catch(error) {
          console.log(error);
        } finally {
        this.$emit('setLoadingScreen', false);
        }
      },
      handleSubmit() {
        this.loading = true;
        let validate = this.verifyErrors();

        if(!validate){
          this.loading = false;
          return false;
        }
        

        if(this.customer.health_information == null){
          this.customer.health_information = {allergies: this.allergies};
        }else{
          this.customer.health_information.allergies = this.allergies;
        }
        
        let date = new Date(this.customer.birth_date);
        this.customer.birth_date = date.getFullYear() + '-' + (this.aditionalZero(date.getMonth() + 1)) + '-' + (this.aditionalZero(date.getDate()));
        this.customer.profile_picture = null;

        POST_CUSTOMER(this.customer).then(
          resp => {
            this.loading = false,
            this.$emit('updateCustomer', this.customer);
          }
        )
      },
      aditionalZero(number) {
          if (number <= 9) 
              return "0" + number;
          else
              return number; 
      },
      verifyErrors() {
        let validate = true;
        this.errors = [];
        this.allergies.map((allergy, x) => {
            if(allergy == '' || allergy == null){
            this.errors[x] = 'Preencha o campo com sua alergia';
            validate = false;
            }
        });
        return validate;
      },
      addAllergy() {
        this.allergies.push('');
      },
      reomveAllergy(x) {
        this.allergies.splice(x, 1);
      }
    },
    mounted() {
      this.getCustomer();
    }
  }
</script>

<style scoped>
  .input-box {
    margin-bottom: 0.5rem;
  }
  .trash-icon {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    align-content: center;
    top: calc(50% - 9px);
    right: 8px;
    cursor: pointer;
  }

  .btn-plus{
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-size: 35px;
    padding: 0;
    margin-bottom: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/CardHealthId/EditAllergies.vue